/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { Field } from "formik";
import Tick from "./tick.svg";
import { colors } from "../../theme";

const checkboxStyle = css`
    display: flex;
    align-items: center;

    span {
        padding-left: 10px;
        cursor: pointer;
    }

    input {
        opacity: 0;
        visibility: hidden;
        position: absolute;
    }

    input:checked ~ div {
        border: none;
    }

    input:checked ~ div::after {
        opacity: 1;
        transform: scale(1);
    }

    div {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: ${colors.neutral0};
        border: 1px solid ${colors.neutral4};
        transition: all 0.15s cubic-bezier(0, 1.05, 0.72, 1.07);
    }

    div::after {
        content: "";
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 4;
        position: absolute;
        transform: scale(0);
        background-size: 100%;
        background-image: url(${Tick});
        background-repeat: no-repeat;
        background-position: center;
        transition: all 0.25s cubic-bezier(0, 1.05, 0.72, 1.07);
    }
`;

export const Checkbox = ({ checked, onChange, label }) => (
    <label css={checkboxStyle}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <div />
        <span>{label}</span>
    </label>
);

export const FormikCheckbox = props => {
    return (
        <Field name={props.name}>
            {({ field, form }) => (
                <label css={checkboxStyle}>
                    <input
                        label={props.label}
                        type="checkbox"
                        checked={field.value.includes(props.value)}
                        onChange={() => {
                            if (field.value.includes(props.value)) {
                                const nextValue = field.value.filter(
                                    value => value !== props.value
                                );
                                form.setFieldValue(props.name, nextValue);
                            } else {
                                const nextValue = field.value.concat(
                                    props.value
                                );
                                form.setFieldValue(props.name, nextValue);
                            }
                        }}
                    />
                    <div data-testid={props["data-testid"]} />
                    <span>{props.label}</span>
                </label>
            )}
        </Field>
    );
};

const CheckboxGroup = ({ children, additionalStyles, ...props }) => (
    <div
        {...props}
        css={[
            css`
                display: flex;
                flex-direction: column;
                & label {
                    margin-top: 8px;
                    margin-bottom: 8px;
                }
            `,
            additionalStyles,
        ]}
    >
        {children}
    </div>
);

export default CheckboxGroup;
